import { useEffect, useState } from "react";
import { NotebookPen } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useContactOptions } from "@/lib/lookups";
import { notifyReviewChanged } from "@/lib/useReviewCount";

export const SaveAsNote = ({ captureId, onSaved }) => {
  const [type, setType] = useState("contact");
  const [id, setId] = useState("");
  const [opps, setOpps] = useState([]);
  const contacts = useContactOptions();
  useEffect(() => { api.get("/opportunities").then((r) => setOpps(r.data.items)).catch(() => {}); }, []);
  const options = type === "contact" ? contacts.map((c) => [c.id, c.name]) : opps.map((o) => [o.id, o.title]);
  const save = async () => {
    try {
      const { data } = await api.post(`/captures/${captureId}/save-note`, { entity_type: type, entity_id: id });
      notifyReviewChanged();
      toast.success("Nota guardada en la línea de tiempo");
      onSaved(data);
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div data-testid="save-as-note" className="c-card p-4 space-y-2.5">
      <p className="text-sm font-semibold flex items-center gap-1.5"><NotebookPen className="w-4 h-4 c-accent" /> No hay acciones que confirmar</p>
      <p className="text-xs c-text-2">Guarda la transcripción como nota en la línea de tiempo de un contacto o negocio, o descártala.</p>
      <div className="grid grid-cols-2 gap-1 p-1 rounded-xl bg-[var(--c-elev)]">
        {[["contact", "Contacto"], ["opportunity", "Negocio"]].map(([k, l]) => (
          <button key={k} data-testid={`save-note-type-${k}`} onClick={() => { setType(k); setId(""); }} className={`py-2 rounded-lg text-sm font-semibold ${type === k ? "bg-[var(--c-card)] c-accent" : "c-muted"}`}>{l}</button>
        ))}
      </div>
      <select data-testid="save-note-entity-select" className="c-input" value={id} onChange={(e) => setId(e.target.value)}>
        <option value="">Elige {type === "contact" ? "un contacto" : "un negocio"}…</option>
        {options.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
      </select>
      <button data-testid="save-note-btn" disabled={!id} onClick={save} className="c-btn-primary w-full py-3">Guardar como nota</button>
    </div>
  );
};
